module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-dress-image-4-d58157f73c1649509a47c9258f1924eb.png";